import React from 'react';
import { StarIcon, CheckCircleIcon, HeartIcon, ShieldCheckIcon } from 'lucide-react';
export function BabyProductHero() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8 md:py-12 lg:py-16 bg-gradient-to-br from-baby-blue-light via-baby-lavender to-baby-pink-light" data-id="element-180">
      <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 xl:gap-16 items-center" data-id="element-181">
        {/* Product Image */}
        <div className="space-y-4 sm:space-y-6 animate-fade-in-up" data-id="element-182">
          <div className="relative animate-float" data-id="element-183">
            <div className="absolute -inset-2 sm:-inset-3 md:-inset-4 bg-gradient-to-r from-baby-pink-light to-baby-blue-light rounded-baby-lg blur-2xl opacity-40" data-id="element-184"></div>
            <div className="relative" data-id="element-185">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/umd9RTX2VMgZXBdHQoQ62X/portada_30_recetas_para_bebes.png" alt="30 Recetas para Bebés - Portada del ebook mostrando mamá alimentando a su bebé" className="w-full max-w-md mx-auto rounded-baby-lg shadow-baby-glow" data-id="element-186" />
            </div>
            {/* Floating Badge */}
            <div className="absolute -top-3 -right-3 sm:-top-4 sm:-right-4 bg-baby-gradient-pink text-white px-4 py-2 sm:px-5 sm:py-2.5 rounded-full shadow-baby-pink transform rotate-12 animate-soft-pulse" data-id="element-187">
              <div className="text-sm sm:text-base md:text-lg font-extrabold" data-id="element-188">
                EDICIÓN PREMIUM
              </div>
            </div>
          </div>
        </div>

        {/* Product Info */}
        <div className="space-y-4 sm:space-y-5 md:space-y-6 animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-189">
          {/* Badge and Reviews */}
          <div className="flex items-center gap-2 sm:gap-3 flex-wrap" data-id="element-190">
            <div className="inline-flex items-center gap-1.5 bg-baby-gradient-pink-blue text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-bold shadow-baby-soft" data-id="element-191">
              <span data-id="element-192">💝</span>
              <span data-id="element-193">Para Mamás Primerizas</span>
            </div>
            <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full shadow-baby-soft border-2 border-baby-pink-light" data-id="element-194">
              <div className="flex" data-id="element-195">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 sm:w-4 sm:h-4 fill-yellow-400 text-yellow-400" data-id="element-196" />)}
              </div>
              <span className="text-xs sm:text-sm font-bold text-gray-900" data-id="element-197">
                487 Mamás
              </span>
            </div>
          </div>

          {/* Title */}
          <div data-id="element-198">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2 sm:mb-3 bg-gradient-to-r from-baby-pink via-baby-lavender to-baby-blue bg-clip-text text-transparent leading-tight" data-id="element-199">
              Del Caos al Control
            </h1>
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-gray-900 font-bold leading-snug mb-3" data-id="element-200">
              30 Recetas Seguras y Nutritivas Para Alimentar a Tu Bebé Sin Miedo
              Ni Culpa
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-800 leading-relaxed font-medium" data-id="element-201">
              Haz comida casera para tu bebé, aunque llegues agotada y no sepas
              por dónde empezar. Con este método paso a paso, sabrás qué hacer
              cada día.
            </p>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 stagger-children" data-id="element-202">
            <div className="flex items-center gap-3 bg-white/80 backdrop-blur-baby p-3 sm:p-4 rounded-baby border-2 border-baby-blue-light shadow-baby-soft hover:shadow-baby-glow transition-all" data-id="element-203">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-baby-gradient-blue rounded-full flex items-center justify-center shadow-baby-soft" data-id="element-204">
                <ShieldCheckIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-205" />
              </div>
              <div className="text-sm sm:text-base font-bold text-gray-900" data-id="element-206">
                Recetas Seguras
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white/80 backdrop-blur-baby p-3 sm:p-4 rounded-baby border-2 border-baby-pink-light shadow-baby-soft hover:shadow-baby-glow transition-all" data-id="element-207">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-baby-gradient-pink rounded-full flex items-center justify-center shadow-baby-pink" data-id="element-208">
                <HeartIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-209" />
              </div>
              <div className="text-sm sm:text-base font-bold text-gray-900" data-id="element-210">
                Sin Culpa
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white/80 backdrop-blur-baby p-3 sm:p-4 rounded-baby border-2 border-baby-pink-light shadow-baby-soft hover:shadow-baby-glow transition-all" data-id="element-211">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-baby-gradient-pink rounded-full flex items-center justify-center shadow-baby-pink" data-id="element-212">
                <span className="text-xl sm:text-2xl" data-id="element-213">👶</span>
              </div>
              <div className="text-sm sm:text-base font-bold text-gray-900" data-id="element-214">
                Por Edad y Textura
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white/80 backdrop-blur-baby p-3 sm:p-4 rounded-baby border-2 border-baby-blue-light shadow-baby-soft hover:shadow-baby-glow transition-all" data-id="element-215">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-baby-gradient-blue rounded-full flex items-center justify-center shadow-baby-soft" data-id="element-216">
                <CheckCircleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-217" />
              </div>
              <div className="text-sm sm:text-base font-bold text-gray-900" data-id="element-218">
                Paso a Paso
              </div>
            </div>
          </div>

          {/* Trust Badges */}
          <div className="flex items-center justify-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-800 flex-wrap font-semibold" data-id="element-219">
            <div className="flex items-center gap-1.5" data-id="element-220">
              <CheckCircleIcon className="w-4 h-4 text-baby-blue flex-shrink-0" data-id="element-221" />
              <span data-id="element-222">Descarga Instantánea</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-223">
              <CheckCircleIcon className="w-4 h-4 text-baby-pink flex-shrink-0" data-id="element-224" />
              <span data-id="element-225">Garantía 30 Días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-226">
              <CheckCircleIcon className="w-4 h-4 text-baby-lavender flex-shrink-0" data-id="element-227" />
              <span data-id="element-228">Soporte LATAM</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}